// src/components/Dashboard/DashboardNav.tsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const DashboardNav: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className="dashboard-nav">
      <ul>
        <li className={isActive('/dashboard') || isActive('/')}>
          <Link to="/dashboard">Главная</Link>
        </li>
        <li><a href="#robots">Роботы</a></li>
        <li><a href="#settings">Настройки</a></li>
        <li><a href="#help">Помощь</a></li>
      </ul>
    </nav>
  );
};

export default DashboardNav;